import { cloneDeep } from 'lodash';
import Constant from '../../common/constant/Constant';
import Utils from '@/common/utils/utils';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { userAtom } from '@/state/atom/userAtom';
import { getListCustomFiledOfForm } from '../ticketList/handler/TicketHandler';
import { corporationAtom } from '@/state/atom/corporationAtom';
import CloseIcon from '@material-ui/icons/Close';
import { AISystemField } from '@/common/constant/SystemField';
import { formPanelTabCloseManagementAtom } from '@/state/atom/formAtom';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
// Use ESM import (not require) so webpack resolves these lazily at call time.
// formManagement has a circular import cycle (FormListHandler -> CommonHandler -> AddField* -> FormListHandler),
// and a top-level require destructuring reads the exports while FormListHandler is still evaluating (TDZ error).
import { handleOnClickDeleteForm, getDefaultSynonymSettingWhenDuplicateForm } from './handler/FormListHandler';

const {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Popover,
    DialogContentText
} = require('@material-ui/core');
const { useState } = require('react');

function ConfirmModal(props) {
    const handleCloseConfirmModal = () => {
        props.setOpenConfirmModal(false);
    };

    return (
        <Dialog
        open={props.openConfirmModal}
        onClose={() => handleCloseConfirmModal()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="alert-dialog-delete-addition-user"
        >
            <DialogContent>
                <DialogContentText id="alert-dialog-delete-addition-user-content">
                {trI18n('COMMSG016')}
                </DialogContentText>
            </DialogContent>
            <DialogActions className="confirm-delete-user-dialog-action">
                <Button
                    onClick={props.submitConfirm}
                    autoFocus
                    className="btn-handle-delete-user btn-handle-delete-user-agree"
                >
                    {trI18n('COMBTN002')}
                </Button>
                <Button
                    onClick={(event, reason) => handleCloseConfirmModal(event, reason)}
                    className="btn-light btn-hg32 btn-handle-delete-user btn-handle-delete-user-disagree"
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    )
};


export default function RenderMoreAction({ item, projectInuseDetail, argsAll }) {
    // Subscribe to translation updates so displayed labels re-render on language change
    useTranslationSubscription();
    const corporationDetail = useRecoilValue(corporationAtom);
    const currentCorporationId = projectInuseDetail.affiliationOrganization;
    const currentProjectId = projectInuseDetail.id;
    const userDetail = useRecoilValue(userAtom);

    // manager edited state form, field screen, close panel atom 
    const setFormPanelTabClose = useSetRecoilState(formPanelTabCloseManagementAtom);

    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [isOpenCannotDeletePopup,setIsOpenCannotDeletePopup] = useState(false)
    const open = Boolean(anchorEl);
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const isDisplayDeleteAction = () => {
        if (!item.isInuse && item.affiliationProject === currentProjectId) {
            return true;
        }
        return false;
    };

    const isDisplayDuplicateAction = () => {
        if (item.promptKnowledgeFormFlag) {
            return false;
        }
        return true;
    };

    const preprareFormStructure = (fieldDataInForm) => {
        let newStructure = item.structure;
        if (newStructure) {
            newStructure = Utils.convertJSONDataToObject(newStructure)
        }
        let structureResult = {};
        let index = 1;

        if (!Utils.isEmptyObject(newStructure)) {
            for (const structureKey in newStructure) {
                if (isNaN(Number(structureKey))) {
                    structureResult[structureKey] = newStructure[structureKey];
                    continue;
                }
        
                const structureChild = newStructure[structureKey];
                if (structureChild?.field) {
                    let currentfieldId = structureChild?.field;
                    let currentFieldDetail = fieldDataInForm.find(field => field.id === currentfieldId);
                    if (currentFieldDetail && AISystemField.includes(currentFieldDetail?.sysField)) {
                        continue;
                    }
                }
        
                structureResult[index] = structureChild;
                index++;
            }
        }
        return structureResult;
    }
    
    const onClickDuplicateForm = async () => {
        handleClose();
        let formDuplicate = cloneDeep(item);
        let formDuplicateName = `${Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, formDuplicate.name)} - Copy`;
        formDuplicate.name = JSON.stringify({
            jp: {
                A: 'F',
                text: formDuplicateName,
            }
        })
        // if (item.isShared && item.affiliationOrganization !== currentCorporationId) {
            argsAll.setIsLoading(true);
            let originStructure = item.structure;
            let settingTitle =Utils.convertJSONDataToObject(originStructure)?.formTitle;
            
            let originStructureObject = Utils.convertJSONDataToObject(originStructure);
            let newStructure = item.structure;
            let fieldDataInForm = await getListCustomFiledOfForm(originStructureObject, argsAll.API, item.affiliationOrganization);
            let defaultFieldAddList = [];
            let newFieldListInState = cloneDeep(argsAll.fieldListInState);
            // let newStructure = !Utils.isEmptyObject(preprareFormStructure(fieldDataInForm)) ? JSON.stringify(preprareFormStructure(fieldDataInForm)) : item.structure;
            // fieldDataInForm = fieldDataInForm.filter(field => !AISystemField.includes(field?.sysField));

            if (!Utils.isEmptyArray(fieldDataInForm)) {
                fieldDataInForm.forEach(originField => {
                    if (originField.definition === Constant.FORM_DEFINITION.SYSTEM && originField.sysField) {
                        let originFieldId = originField.id;
                        let currentSystemField = argsAll.fieldListInState.find(corpSystemField => corpSystemField.definition === Constant.FORM_DEFINITION.SYSTEM && corpSystemField.sysField === originField.sysField);
                        if (!Utils.isEmptyObject(currentSystemField)) {
                            newStructure =  newStructure.replace(originFieldId, currentSystemField.id);
                            const indexOfReplaceField = settingTitle?.findIndex(field => {
                                return field.id === originFieldId
                            })

                            if(indexOfReplaceField > -1) {
                                let replaceFieldInTitle = settingTitle[indexOfReplaceField];
                                if(!Utils.isEmptyObject(replaceFieldInTitle)){
                                    replaceFieldInTitle.id = currentSystemField.id;
                                    settingTitle[indexOfReplaceField]  = replaceFieldInTitle;
                                }
                            }
                        }
                    } else {
                        // status field
                        if (originField.type === Constant.FORM_TYPE.FIELD_WORKFLOW) {
                            let originFieldId = originField.id;
                            let currentProjectStatusField = argsAll.fieldListInState.find(corpField => corpField.type === Constant.FORM_TYPE.FIELD_WORKFLOW && corpField.affiliationProject === currentProjectId);
                            if (!Utils.isEmptyObject(currentProjectStatusField)) {
                                newStructure =  newStructure.replace(originFieldId, currentProjectStatusField.id);
                                const indexOfReplaceField = settingTitle?.findIndex(field => {
                                    return field.id === originFieldId
                                })
    
                                if(indexOfReplaceField > -1) { 
                                    let replaceFieldInTitle = settingTitle[indexOfReplaceField]

                                    if (!Utils.isEmptyObject(replaceFieldInTitle)) {
                                        replaceFieldInTitle.id = currentProjectStatusField.id;
                                        settingTitle[indexOfReplaceField] = replaceFieldInTitle;
                                    }
                                }
                            }
                        } else {
                            let newFieldId = `${Date.now().toString()}-${originField.id}`;
                            let fieldAddNew = cloneDeep(originField);
                            fieldAddNew.affiliationOrganization = currentCorporationId;
                            fieldAddNew.affiliationProject = currentProjectId;
                            fieldAddNew.clientFieldType = Constant.CLIENT_FIELD_TYPE.ADD_NEW_FIELD;
                            fieldAddNew.structure = Utils.convertJSONDataToObject(originField.structure);
                            fieldAddNew.explanation = Utils.convertJSONDataToObject(originField.explanation);
                            fieldAddNew.usingProjects = [currentProjectId];
                            fieldAddNew.creator = userDetail.id;
                            fieldAddNew.updator = userDetail.id;
                            fieldAddNew.isProjectInuse = true;
                            fieldAddNew.isUsingProject = true;
                            fieldAddNew.isUsingForm = true;
                            fieldAddNew.usingForms = {};
                            fieldAddNew.id = newFieldId;
                            fieldAddNew.shareOption = 1;
                            fieldAddNew.shareRange = [];

                            let fieldName;
                            let nameCloneField = {};
                            try {
                                fieldName = Utils.convertJSONDataToObject(originField.name);
                            } catch (err) {
                                fieldName = { ...originField.name };
                            }
                        
                            nameCloneField[Constant.LANGUAGE_TYPE.JP] = {
                                A: 'F',
                                text: `${Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, fieldName)} - Copy`
                            };
                            fieldAddNew.name = nameCloneField;

                            // Add item and default item for tag field
                            if (originField.type === Constant.FORM_TYPE.FIELD_TAG && !Utils.isEmptyArray(newFieldListInState)) {
                                let originFieldData = newFieldListInState.find(field => field.id === originField.id);
                                if (!Utils.isEmptyObject(originFieldData)) {
                                    let newItemList = !Utils.isEmptyArray(originFieldData.itemList) ? originFieldData.itemList : [];
                                    let newDefaultItemList = !Utils.isEmptyArray(originFieldData.defaultItemList) ? originFieldData.defaultItemList : [];
                                    if (!Utils.isEmptyArray(newItemList)) {
                                        newItemList.map(tagItem => {
                                            tagItem.hitNumber = 0;
                                        })
                                    }

                                    if (!Utils.isEmptyArray(newDefaultItemList)) {
                                        newDefaultItemList.map(tagItem => {
                                            tagItem.hitNumber = 0;
                                        })
                                    }

                                    fieldAddNew.itemList = newItemList;
                                    fieldAddNew.defaultItemList = newDefaultItemList;
                                }
                            }

                            defaultFieldAddList.push(fieldAddNew);
                            newFieldListInState.push(fieldAddNew);
                            newStructure =  newStructure.replace(originField.id, newFieldId);

                            const indexOfReplaceField = settingTitle?.findIndex(field => {
                                return field.id === originField.id
                            })

                            if(indexOfReplaceField > -1) { 
                                let replaceFieldInTitle = settingTitle[indexOfReplaceField]
                                if (!Utils.isEmptyObject(replaceFieldInTitle)) {
                                    replaceFieldInTitle.id = newFieldId;
                                    settingTitle[indexOfReplaceField] = replaceFieldInTitle;
                                }
                            }
                        }
                    }
                })
            }
            newStructure = Utils.convertJSONDataToObject(newStructure)
            
            newStructure.formTitle = settingTitle
            formDuplicate.structure = newStructure;
            formDuplicate.affiliationOrganization = currentCorporationId;
            formDuplicate.affiliationProject = currentProjectId;
            formDuplicate.creator = userDetail.id;
            formDuplicate.updator = userDetail.id;
            formDuplicate.usage = Constant.FORM_USAGE.FORM;
            formDuplicate.defaultFieldAddList = defaultFieldAddList;
            formDuplicate.shareOption = 1;
            formDuplicate.shareRange = [];
            formDuplicate.additionalCreateTicketForOwnerPermission = [];
            formDuplicate.isSynonym = getDefaultSynonymSettingWhenDuplicateForm(item.isSynonym, item.type, corporationDetail, projectInuseDetail);
        

            argsAll.setFieldListInState(newFieldListInState);
        // }

        argsAll.setFormEdit(formDuplicate);
        argsAll.setIsDuplicateForm(true);
        argsAll.setIsLoading(false);
        
        setFormPanelTabClose(prev => ({...prev, isDirty: true}));

        argsAll.setActionType(Constant.ACTION_LIST_FORM.DUPLICATE_FORM);
        if(argsAll.isChangeData){
            argsAll.setIsOpenConfirmRedirect(true);
        }else{
            argsAll.setOpenScreen(Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM);
        }
    }


    return (
        <div className="listManage-item">
            <IconButton
                className="itemTools"
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <img src="/assets/image/icon-nav-manage.svg" alt="" />
            </IconButton>
            <Popover
                className="nav-addManage"
                id={open ? 'simple-popover' : undefined}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            >
                <ul>
                    { item.affiliationProject !== projectInuseDetail.id && (
                        <li onClick={() => {
                            handleClose();
                            argsAll.onOpenEditForm(item)
                        }}>
                            <span className="item">
                                <img src="/assets/image/view-detail.svg" alt="" />
                            </span>
                            <span className="text">{tr('閲覧')}</span>
                        </li>
                    )}

                    {item.affiliationProject === projectInuseDetail.id && 
                    (
                    <li onClick={() => {
                        handleClose();
                        argsAll.onOpenEditForm(item)
                        }}>
                        <span className="item">
                            <img src="/assets/image/edit-icon.svg" alt="" />
                        </span>
                        <span className="text">{trI18n('USER01BTN007')}</span>
                    </li>)}

                    {/* {isDisplayDuplicateAction() &&  */}
                        <li onClick={onClickDuplicateForm}>
                            <span className="item" >
                                <img src="/assets/image/icon-copy.svg" alt="" />
                            </span>
                            <span className="text">{trI18n('FIELDFORMBTN013')}</span>
                        </li>
                    {/* } */}

                    {isDisplayDeleteAction(item) && (
                        <li
                            onClick={() => {
                                handleClose();
                                setOpenConfirmModal(true);
                            }}
                        >
                            <span className="item">
                                <img src="/assets/image/icon-tabs-delete.svg" alt="" />
                            </span>
                            <span className="text">{trI18n('USER01LB006')}</span>
                        </li>
                    )}
                </ul>
            </Popover>
            <ConfirmModal
                openConfirmModal={openConfirmModal}
                setOpenConfirmModal={setOpenConfirmModal}
                submitConfirm={() => {
                    return handleOnClickDeleteForm(
                        {
                            setOpenConfirmModal: setOpenConfirmModal,
                            projectInuseDetail: projectInuseDetail,
                            setIsOpenCannotDeletePopup: setIsOpenCannotDeletePopup,
                            ...argsAll
                        },
                        item
                    );
                }}
            />
            <Dialog
            open={isOpenCannotDeletePopup}
            onClose={(event, reason) => setIsOpenCannotDeletePopup(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                {tr('このフォーマットはナレッジロボの質問カテゴリ設定に使用されているため削除できません。')}
                    <IconButton
                        className="close"
                        onClick={(event, reason) => setIsOpenCannotDeletePopup(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="confirm-dialog-button"
                    variant="contained"
                    color="primary"
                    onClick={() => setIsOpenCannotDeletePopup(false)}
                >
                    {tr('いいえ')}
                </Button>
            </DialogActions>
        </Dialog>
        </div>
    );
}
